import React from "react";
import ReactMarkdown from "react-markdown";

import { CardContainer, CardTitle, CardSubtitle, CardText } from "./styles";

function CardSimples({ text }) {
  return (
    <CardContainer>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
        }}
      >
        <img
          src="/bradescoexclusive/assets/check.svg"
          alt="check"
          style={{ paddingTop: "7px", paddingRight: "10px" }}
        />
        <CardSubtitle>{text}</CardSubtitle>
      </div>
    </CardContainer>
  );
}

export default CardSimples;
